import { render, staticRenderFns } from "./ThemeColorConfig.vue?vue&type=template&id=10868366&scoped=true&"
import script from "./ThemeColorConfig.vue?vue&type=script&lang=js&"
export * from "./ThemeColorConfig.vue?vue&type=script&lang=js&"
import style0 from "./ThemeColorConfig.vue?vue&type=style&index=0&id=10868366&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10868366",
  null
  
)

export default component.exports